import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequestActivity } from '../services/_http'
import { QueryKeys } from './_query_keys'

export interface FetchUserIdByMobileResponse {
  userId: string
  mobileNumber: string
  success: boolean
}

export interface FetchUserIdByMobileError {
  message: string
  error: string
}

export const useGetUserHistory = (
  mobileNumber: string,
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'
  const queryKey = [QueryKeys.USER_HISTORY, mobileNumber]

  return useQuery({
    queryKey,
    queryFn: () =>
      HttpRequestActivity({
        url: `api/${APIEndpoints.Activity}/users/${mobileNumber}/history`,
        method,
      }),
    enabled: false,
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useGetUserAffinity = (
  mobileNumber: string,
  options?: UseQueryOptions
): UseQueryResult<any> => {
  const method = 'GET'
  const queryKey = [QueryKeys.USER_AFFINITY, mobileNumber]

  return useQuery({
    queryKey,
    queryFn: () =>
      HttpRequestActivity({
        url: `api/${APIEndpoints.Activity}/user-affinity/${mobileNumber}`,
        method,
      }),
    enabled: false,
    refetchOnWindowFocus: false,
    ...options,
  })
}

export const useGetPersonalizedData = (options?: any) => {
  const method = 'POST'

  return useMutation(
    ({ data }: { data: any }) =>
      HttpRequestActivity({
        url: `api/${APIEndpoints.Activity}/user-activity/personalize`,
        method,
        data,
      }),
    options
  )
}
